import { Button } from 'vant'

// 禁止gif动代码
if ('getContext' in document.createElement('canvas')) {
  HTMLImageElement.prototype.play = function () {
    if (this.storeCanvas) {
      // 移除存储的canvas
      this.storeCanvas.parentElement.removeChild(this.storeCanvas)
      this.storeCanvas = null
      // 透明度还原
      image.style.opacity = ''
    }
    if (this.storeUrl) {
      this.src = this.storeUrl
    }
  }
  HTMLImageElement.prototype.stop = function () {
    var canvas = document.createElement('canvas')
    // 尺寸
    var width = this.width, height = this.height
    if (width && height) {
      // 存储之前的地址
      if (!this.storeUrl) {
        this.storeUrl = this.src
      }
      // canvas大小
      canvas.width = width
      canvas.height = height
      // 绘制图片帧（第一帧）
      canvas.getContext('2d').drawImage(this, 0, 0, width, height)
      // 重置当前图片
      try {
        this.src = canvas.toDataURL('image/gif')
      } catch (e) {
        // 跨域
        this.removeAttribute('src')
        // 载入canvas元素
        canvas.style.position = 'absolute'
        // 前面插入图片
        this.parentElement.insertBefore(canvas, this)
        // 隐藏原图
        this.style.opacity = '0'
        // 存储canvas
        this.storeCanvas = canvas
      }
    }
  }
}
let local = {
  baidu () {
    (function () {
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?85f1e4eaf47a9af09ca719e73c93fca9'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  },
  // 设置页面标题
  setTitle (str = '邀你入驻小希-留学顾问圈',
    description = '邀你入驻小希-留学顾问圈，一键查询留学一手资讯、海外院校信息，随时分发内容获取学生资源。',
    metaDescription = '一键查询留学一手资讯、海外院校信息，随时分发内容获取学生资源。',
    imgUrl = 'http://aojixiaoxi.ks3-cn-beijing.ksyun.com/smart/smartlogo.png'
  ) {
    try {
      console.log('set title begin!')
      document.title = str
      document.getElementsByName('description')[0].setAttribute('content', metaDescription)
      if (!dd || !dd.ready) return
      dd.ready(function () {
        // console.log('set title dd ready!')
      })
      var path = window.location.origin
      var url = window.location.href

      // 检查是否为 免登陆分享页面，如果是，分享时直接，分享出去免登陆页面
      var replaceUrlQueryParam = (nowurl, needstr) => {
        if (url.includes(nowurl)) {
          var reg = new RegExp(nowurl, 'g')
          url = url.replace(reg, needstr)
          return true
        } else {
          return false
        }
      }
      // 智能选校分享
      if (replaceUrlQueryParam('/main/home/select-school/choice-result', '/main/home/select-school/share-choice-result')) { }
      // 顾问详情分享
      else if (replaceUrlQueryParam('/main/my/consultant-details', '/main/my/share-consultant-details')) { }
      // 服务详情分享
      else if (replaceUrlQueryParam('/main/service/detail', '/main/service/share-detail')) { }
      // 成功案例详情分享
      else if (replaceUrlQueryParam('/main/school/success-case-details', '/main/school/share-success-case-details')) { }
      // 院校详情分享
      else if (replaceUrlQueryParam('/main/school/school-details', '/main/school/share-school-details')) { }
      // 文章详情页面分享
      else if (replaceUrlQueryParam('/main/my/my-article-details', '/main/my/share-article-details')) { } else if (replaceUrlQueryParam('/main/study/article-details', '/main/my/share-article-details')) { }

      // console.log("dd:" + dd)

      // console.info("share title " + str);
      // console.info("share desc " + description);
      // console.info("share url " + url);
      // console.info("share imgUrl " + imgUrl);

      // 查看是否可以调用内置钉钉浏览器
      if (dd) {
        dd.biz.navigation.setTitle({
          title: str, // 控制标题文本，空字符串表示显示默认文本
          onSuccess: function (result) {
            /* 结构
            {
            } */
          },
          onFail: function (err) {
            // alert('钉钉设置标题失败')
          }
        })

        // 钉钉右上角更多事件控制
        dd.biz.navigation.setRight({
          show: true, // 控制按钮显示， true 显示， false 隐藏， 默认true
          control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
          text: '···', // 控制显示文本，空字符串表示显示默认文本
          onSuccess: function (result) {
            // alert("开始分享")
            // 如果control为true，则onSuccess将在发生按钮点击事件被回调
            // check share url ---------------------------------------------
            // 钉钉内置分享
            dd.biz.util.share({
              type: 0, // 分享类型，0:全部组件 默认； 1:只能分享到钉钉；2:不能分享，只有刷新按钮
              url: url,
              title: str,
              content: description,
              image: imgUrl,
              onSuccess: function () {
                // onSuccess将在调起分享组件成功之后回调
                /**/
                // alert('分享成功')
              },
              onFail: function (err) {
                alert('分享失败')
              }
            })
          },
          onFail: function (err) {
            alert('点击右上角失败')
          }
        })
      }
      // 查看是否可以调用微信内置浏览器
      wx.ready(function () {
        console.log('设置微信分享')
        // 分享到朋友圈
        wx.onMenuShareTimeline({
          title: str, // 分享标题
          link: url, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        })
        // 分享到朋友
        wx.onMenuShareAppMessage({
          title: str, // 分享标题
          desc: description, // 分享描述
          link: url, // 分享链接
          imgUrl: imgUrl, // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        })
        // 分享到qq
        wx.onMenuShareQQ({
          title: str, // 分享标题
          desc: description, // 分享描述
          link: url, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        })
        // 分享到空间
        wx.onMenuShareQZone({
          title: str, // 分享标题
          desc: description, // 分享描述
          link: url, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        })
      })
    } catch (error) {
      console.error(error)
    }
  },
  share (route) {
    var replaceQueryParam = (param, newval, search) => {
      var regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?')
      var query = search.replace(regex, '$1').replace(/&$/, '')
      return (
        (query.length > 2 ? query + '&' : '?') +
        (newval ? param + '=' + newval : '')
      )
    }

    if (!route.query.refresh) {
      var chat = '&'
      if (!Object.keys(route.query).length) {
        chat = '?'
      }
      try {
        // 如果在微信浏览器中执行该代码，解决微信中复制动态链接
        console.log('share wx check')
        // if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
        //   console.log('share wx check yes')
        //   window.location.replace(
        //     location.protocol +
        //     '//' +
        //     location.host +
        //     location.pathname +
        //     replaceQueryParam('_wxr_', new Date().getTime(), location.search) +
        //     location.hash +
        //     chat + 'refresh=true'
        //   )
        // } else {
        //   console.log('share wx check no')
        // }
      } catch (error) {
        console.error(error)
      }
    } else {
      this.setTitle(route.meta.title, route.meta.description || '提供大数据选校、海量院校库、院校培训课程和最新留学资讯，致力成为留学顾问的工作助手，让留学申请变得更简单、更智能。')
    }
  },
  nogifrepeat () {
    setTimeout(() => {
      var image = $('img')
      for (let index = 0; index < image.length; index++) {
        const element = image[index]
        if (!element.src) continue
        var type =
          '|' +
          element.src.slice(element.src.lastIndexOf('.') + 1) +
          '|'
        if ('|gif|'.indexOf(type) !== -1) {
          element.stop()
        }
      }
    }, 500)
  }
}

export default {
  install: function (vm) {
    vm.prototype.$statistics = local
  },
  getLocal: local
}



// WEBPACK FOOTER //
// ./src/util/Statistics.js